import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { ProjectSettingsService } from 'src/app/core/services/common/project-settings.service';
import { CatService } from 'src/app/shared/services/catalog/cat.service';
import { UrbanArea, Region } from 'src/app/shared/interfaces/certify/urban-area';
import { CatalogsInterface } from './catalogs.models';

@Injectable({ providedIn: 'root' })
export class CatalogsStoreService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
    private catService: CatService,
  ) {}

  /**
   * Fetch catalogs, areas, and regions together for global load flow.
   * Returns: { catalogs, areas, regions }
   */
  getCatalogsAreasRegions(): Observable<{ catalogs: CatalogsInterface; areas: UrbanArea[]; regions: Region[] }> {
    return forkJoin({
      catalogs: this.getCatalogs(),
      areas: this.catService.GetAreas().pipe(map((response: { items?: UrbanArea[] }) => response?.items || [])),
      regions: this.catService.getAllRegions().pipe(map((response: { items?: Region[] }) => response?.items || [])),
    });
  }

  getCatalogs(): Observable<CatalogsInterface> {
    const url = this.settings.generateEndpoint(EndpointConstants.ApiCatalogs);
    return this.http.get<CatalogsInterface>(url, this.options);
  }

  /**
   * Fetch only areas and regions (no catalogs).
   * Returns: { areas, regions }
   */
  getAreasRegions(): Observable<{ areas: UrbanArea[]; regions: Region[] }> {
    return forkJoin({
      areas: this.catService.GetAreas().pipe(map((response: { items?: UrbanArea[] }) => response?.items || [])),
      regions: this.catService.getAllRegions().pipe(map((response: { items?: Region[] }) => response?.items || [])),
    });
  }
}
